var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66438 2.53151C4.92313 2.20806 5.3951 2.15562 5.71855 2.41438L13.2185 8.41438C13.3965 8.55671 13.5 8.77219 13.5 9.00003C13.5 9.22787 13.3965 9.44335 13.2185 9.58568L5.71855 15.5857C5.3951 15.8444 4.92313 15.792 4.66438 15.4685C4.40562 15.1451 4.45806 14.6731 4.78151 14.4144L11.5494 9.00003L4.78151 3.58568C4.45806 3.32692 4.40562 2.85495 4.66438 2.53151Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreater);
export default __webpack_public_path__ + "static/media/greater.bc8621c27de792a505a63b586bee924b.svg";
export { ForwardRef as ReactComponent };